import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Button } from '@mui/material';
import { PersonOff, Person, Block, CheckCircle } from '@mui/icons-material';

const ActivateButton = ({
  id,
  onClick = () => {},
  isActive = false,
  isPerson = false,
  dataCy = null,
  disabled = false,
  className,
}) => {
  const label = isActive ? 'Deactivate' : 'Activate';
  return (
    <Tooltip title={label} describeChild>
      <span>
        <Button
          aria-label={label}
          data-cy={dataCy ?? `status-button${id}`}
          onClick={onClick}
          disabled={disabled}
          className={['statusButton', className].filter(Boolean).join(' ')}
          variant="contained"
          style={{ textTransform: 'none' }}
          size="small"
        >
          {isPerson && isActive && <Person />}
          {isPerson && !isActive && <PersonOff />}
          {!isPerson && isActive && <CheckCircle />}
          {!isPerson && !isActive && <Block />}
        </Button>
      </span>
    </Tooltip>
  );
};

ActivateButton.propTypes = {
  id: PropTypes.string,
  dataCy: PropTypes.string,
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
  isPerson: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default ActivateButton;
